// Design system tokens — derived from {dark, accent}

export const NX_COLORS = {
  indigo: '#4338ca',
  teal: '#0f766e',
  graphite: '#1f2937',
  terracotta: '#b45341',
};

export function withAlpha(hex: string, a: number): string {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export interface NxTheme {
  dark: boolean;
  accent: string;
  accentSoft: string;
  accentInk: string;
  paper: string;
  paperAlt: string;
  surface: string;
  surfaceAlt: string;
  ink: string;
  inkSoft: string;
  inkMute: string;
  inkFaint: string;
  border: string;
  borderStrong: string;
  cream: string;
  success: string;
  warning: string;
  danger: string;
}

export function createTheme({ dark = false, accent = NX_COLORS.indigo } = {}): NxTheme {
  if (dark) {
    return {
      dark: true,
      accent,
      accentSoft: withAlpha(accent, 0.18),
      accentInk: '#ffffff',
      paper: '#0c0d10',
      paperAlt: '#15171b',
      surface: '#1a1c21',
      surfaceAlt: '#22252b',
      ink: '#f4f4f3',
      inkSoft: 'rgba(244,244,243,0.72)',
      inkMute: 'rgba(244,244,243,0.5)',
      inkFaint: 'rgba(244,244,243,0.32)',
      border: 'rgba(255,255,255,0.09)',
      borderStrong: 'rgba(255,255,255,0.16)',
      cream: '#15171b',
      success: '#34d399',
      warning: '#fbbf24',
      danger: '#f87171',
    };
  }
  return {
    dark: false,
    accent,
    accentSoft: withAlpha(accent, 0.10),
    accentInk: '#ffffff',
    paper: '#fafaf8',
    paperAlt: '#f3f2ee',
    surface: '#ffffff',
    surfaceAlt: '#fbfaf7',
    ink: '#0a0b0d',
    inkSoft: 'rgba(10,11,13,0.68)',
    inkMute: 'rgba(10,11,13,0.45)',
    inkFaint: 'rgba(10,11,13,0.22)',
    border: 'rgba(10,11,13,0.09)',
    borderStrong: 'rgba(10,11,13,0.18)',
    cream: '#f1ece1',
    success: '#0d8a5e',
    warning: '#b45309',
    danger: '#b91c1c',
  };
}

// Default light theme
export const defaultTheme = createTheme();
